/* eslint-disable import/prefer-default-export */
import ko from 'knockout';

export const isQuickAddOpen = ko.observable(false);
